import store from '@/containers/App/store';
import { getAuthCart, updateAuthCart } from '@/containers/App/auth'
import { setCart } from '@/redux/actions/cartActions';

export const onClickRemoveItem = (index) => {
    if (window.confirm('Are you sure to remove item from your cart?')) {
        removeItem(index);
    }
}

const removeItem = (i) => {
    const cart = getAuthCart();
    // console.log(cart)
    // return;
    for (let j in cart.items) {
        if (parseInt(i) === parseInt(j)) {
            let item = cart.items[j];
            cart.items.splice(j, 1);
        }
    }
    if (updateAuthCart(cart)) {
        store.dispatch(setCart(cart))
    }
}